import React from 'react'
import styled from 'styled-components'
import { DEFAULT_CONFIG } from '../../constants/styledComponents'
import { getTypographyDefaultConfig } from '../../utils/typography.util'

const StyledH1 = styled.h1.withConfig(DEFAULT_CONFIG)(props => ({
    ...getTypographyDefaultConfig(props),
    fontSize: 32,
}))

const H1 = props => (
    <StyledH1
        {...props}
        style={
            props.onClick ? { cursor: 'pointer', ...props.style } : props.style
        }
    >
        {props.children}
    </StyledH1>
)

export default H1
